import { Card, Stack, useTheme, spacing } from '@fti/design-system';
import { DateInput } from '../shared/DateInput';
import { useAvailableModels } from '../../../api/media-sim/models';
import type { ProjectUpdateRequest } from '../../../types/media-sim';

interface WizardStep2Props {
  data: {
    start_date?: string | null;
    model_name?: string;
  };
  onChange: (updates: Partial<ProjectUpdateRequest>) => void;
}

function defaultStartDate(): string {
  const d = new Date();
  d.setDate(d.getDate() - 180);
  return d.toISOString().split('T')[0];
}

export function WizardStep2({ data, onChange }: WizardStep2Props) {
  const { theme } = useTheme();
  const { data: models } = useAvailableModels();

  const modelOptions = (models || []).map((m) => ({
    value: m.id,
    label: m.name,
  }));

  const currentModel =
    data.model_name || models?.find((m) => m.is_default)?.id || '';

  return (
    <Card variant="elevated">
      <Card.Body>
        <Stack gap="md">
          <h3 style={{ margin: 0, color: theme.colors.text.primary }}>
            Date Range & Model
          </h3>

          <DateInput
            label="Project Start Date"
            value={data.start_date?.split('T')[0] || defaultStartDate()}
            onChange={(date) => onChange({ start_date: date })}
          />
          <p
            style={{
              fontSize: '0.75rem',
              color: theme.colors.text.secondary,
              margin: 0,
            }}
          >
            Controls the temporal scope for Milvus searches during simulation
            execution.
          </p>

          <div>
            <label
              style={{
                display: 'block',
                fontSize: '0.85rem',
                fontWeight: 500,
                color: theme.colors.text.primary,
                marginBottom: '4px',
              }}
            >
              AI Model
            </label>
            {modelOptions.length > 0 ? (
              <select
                value={currentModel}
                onChange={(e) => onChange({ model_name: e.target.value })}
                style={{
                  padding: `${spacing.xs} ${spacing.sm}`,
                  border: `1px solid ${theme.colors.border.default}`,
                  borderRadius: '4px',
                  backgroundColor: theme.colors.background.paper,
                  color: theme.colors.text.primary,
                  fontSize: '0.9rem',
                  width: '100%',
                }}
              >
                {modelOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            ) : (
              <p style={{ fontSize: '0.85rem', color: theme.colors.text.secondary }}>
                Loading models...
              </p>
            )}
          </div>
        </Stack>
      </Card.Body>
    </Card>
  );
}
